module.exports = __webpack_public_path__ + "static/Arweave-6d4137c1d41396e9a9fe8fe8f70d6b2f.svg";